import WorkspaceList from "./WorkspaceList";

const index = {
  list: WorkspaceList,
  edit: WorkspaceList,
};

export default index;
